import type { AgendaItem } from "@repo/types";
import { DocumentDisplay } from "./DocumentDisplay";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@repo/ui/components/Base/Tabs";
import { AgendaModuleDisplay } from "../agendaModules/AgendaModuleDisplay";

export const Documents = ({
  tenantId,
  agendaItem,
}: {
  tenantId: string;
  agendaItem: AgendaItem;
}) => {
  return (
    <>
      <div className="p-2">
        <h1 className="text-2xl">Documents</h1>
        <div className="flex flex-col pt-4 w-full">
          {!agendaItem.documents || agendaItem.documents?.length === 0 ? (
            "No documents attached"
          ) : (
            <Tabs defaultValue={agendaItem.documents[0].id} className="w-full">
              <TabsList>
                {agendaItem.documents?.map((doc) => (
                  <TabsTrigger key={doc.id} value={doc.id}>
                    {doc.name}
                  </TabsTrigger>
                ))}
              </TabsList>
              {agendaItem.documents?.map((doc) => (
                <TabsContent key={doc.id} value={doc.id}>
                  <DocumentDisplay documentId={doc.id} tenantId={tenantId} />
                </TabsContent>
              ))}
            </Tabs>
          )}
        </div>
      </div>
      <div className="p-2">
        <h1 className="text-2xl">Agenda Section Used On</h1>
        <div className="flex flex-col pt-4">
          {agendaItem.parentIds?.map((agendaModuleId) => (
            <AgendaModuleDisplay
              key={agendaModuleId}
              agendaModuleId={agendaModuleId}
              tenantId={tenantId}
              showItems={false}
            />
          ))}
        </div>
      </div>
    </>
  );
};
